import { setTrap } from './tab-trap';

window.addEventListener("load", () => {

    const searchTrigger = document.querySelector('.header-search-button');
    const searchOverlay = document.querySelector('.header-search-overlay');
    const searchInput = document.querySelector('.header-search-overlay .header-search-input');
    const searchOverlayClose = document.querySelector('.search-overlay-close-button');

    searchTrigger.addEventListener('click', openSearchOverlay);
    searchOverlayClose.addEventListener('click', closeSearchOverlay);

    searchOverlay.addEventListener('click', function(event) {
        checkClickOutside(event);
    });

    function openSearchOverlay() {
        document.querySelector('html').classList.add('noscroll');
        searchOverlay.classList.add('active');
        searchInput.focus();
        setTrap(searchOverlay);
    }

    function closeSearchOverlay() {
        document.querySelector('html').classList.remove('noscroll');
        searchOverlay.classList.remove('active');
        searchTrigger.focus();
    }

    function checkClickOutside() {
        document.querySelector('.header-search-overlay .background-overlay').addEventListener('mousedown', function() {
            closeSearchOverlay();
        });
    }

    // Close if 'esc' is pressed
    document.onkeydown = function(evt) {
        evt = evt || window.event;

        if (evt.keyCode == 27) {

            if(searchOverlay.classList.contains("active")) {
                closeSearchOverlay();
            }
        }
    };
});
